import { create } from 'zustand';

type EmployeeViewStore = {
  isFormValid: boolean;
  lastChosenPayType: number | null;

  setIsFormValid: (value: boolean) => void;
  setLastChosenAccrualPayType: (payTypeId: number | null) => void;
  reset: () => void;
};

const initialState = {
  isFormValid: true,
  lastChosenPayType: null,
};

export const useEmployeeViewStore = create<EmployeeViewStore>()((set) => ({
  ...initialState,
  setIsFormValid: (value) => set({ isFormValid: value }),
  setLastChosenAccrualPayType: (payTypeId) =>
    set({ lastChosenPayType: payTypeId }),
  reset: () => set(initialState),
}));
